"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDictionaryBySelect = void 0;
const vue_1 = require("vue");
const config_1 = require("./config");
const ComplexSelect_1 = __importDefault(require("@/class/ComplexSelect"));
function buildDictionaryBySelect(selectData, dictionaryInitOption, option = {}) {
    const prop = dictionaryInitOption.prop;
    if (!option.multiple) {
        dictionaryInitOption.format = function (value) {
            return selectData.getItem(value, !option.onlyLabel ? undefined : 'label');
        };
        dictionaryInitOption.showProp = {
            default: !option.onlyLabel ? 'value' : 'label',
            list: 'label'
        };
    }
    else {
        if (option.multiple === 'string') {
            dictionaryInitOption.format = function (value) {
                if (value) {
                    return value.split(',').map((item) => {
                        return selectData.getItem(item, !option.onlyLabel ? undefined : 'label');
                    });
                }
                else {
                    return [];
                }
            };
            dictionaryInitOption.post = function (value) {
                return value ? value.join(',') : '';
            };
        }
        else {
            dictionaryInitOption.format = function (value) {
                if (value) {
                    return value.map((item) => {
                        return selectData.getItem(item, !option.onlyLabel ? undefined : 'label');
                    });
                }
                else {
                    return [];
                }
            };
        }
        dictionaryInitOption.show = function (value) {
            return value.map(item => item.label);
        };
        dictionaryInitOption.edit = function (value) {
            return value.map(item => item.value);
        };
    }
    if (!dictionaryInitOption.mod) {
        dictionaryInitOption.mod = {};
    }
    dictionaryInitOption.mod.edit = Object.assign({ type: 'select', multiple: !!option.multiple, option: {
            optionValue: !option.onlyLabel ? 'value' : 'label',
            list: selectData.getList()
        } }, dictionaryInitOption.mod.edit);
    if (selectData instanceof ComplexSelect_1.default) {
        dictionaryInitOption.mod.edit.reload = true;
        if (dictionaryInitOption.mod.edit.$getData === undefined) {
            dictionaryInitOption.mod.edit.$getData = function () {
                this.$option.list = selectData.getList();
                return Promise.resolve({ status: 'success' });
            };
        }
    }
    if (dictionaryInitOption.mod.list) {
        if (dictionaryInitOption.mod.list.width === undefined) {
            const list = selectData.getList();
            let size = dictionaryInitOption.name.length;
            list.forEach(item => {
                size = Math.max(size, item.label.length);
            });
            dictionaryInitOption.mod.list.width = config_1.listWidth.getWidth(size);
        }
        if (option.color) {
            dictionaryInitOption.mod.list.render = function ({ text, record }) {
                const value = record[prop];
                if (option.color === true) {
                    return (0, vue_1.h)('span', {
                        style: {
                            color: value.color
                        }
                    }, [text]);
                }
                else {
                    return (0, vue_1.h)('span', {
                        style: {
                            color: value.reverseColor,
                            backgroundColor: value.color,
                            width: '100%',
                            display: 'block'
                        }
                    }, [text]);
                }
            };
        }
    }
    if (option.format) {
        dictionaryInitOption = option.format(dictionaryInitOption);
    }
    return dictionaryInitOption;
}
exports.buildDictionaryBySelect = buildDictionaryBySelect;
